import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import ProductListingPageDescriptionUI from 'components/consumer/ProductListingPageDescriptionUI';
const ProductListingPageDescription = () => {
  const $ = _c(3);
  const {
    pageLongDescription,
    pageName
  } = useProductListingPageContext();
  let t0;
  if ($[0] !== pageLongDescription || $[1] !== pageName) {
    t0 = <div className="mx-5 md:mx-0 md:mt-24"><ProductListingPageDescriptionUI label={pageName}>{pageLongDescription}</ProductListingPageDescriptionUI></div>;
    $[0] = pageLongDescription;
    $[1] = pageName;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default ProductListingPageDescription;